import { createFileRoute } from '@tanstack/react-router';
import { ArticlePath, createGuideLink, FeatureFlag, RouteName } from '@mews-commander/enums';
import { BackendPage, getBackendPageUrl } from '@mews-commander/modules';
import {
    ProductServiceDetailPage,
    useGetAdditionalServiceName,
} from '@mews-commander/modules/src/modules/productService';
import { MewsTeam, RouteType } from '@mews/enums';
import { useFeatureFlag } from '@mews/framework';

export const Route = createFileRoute('/_authenticated/$currentEnterpriseId/ProductService/Detail/$id')({
    component: PageComponent,
    staticData: {
        routeName: RouteName.ProductServiceDetail,
        owner: MewsTeam.Services,
        type: RouteType.Backend,
        guideLink: createGuideLink(ArticlePath.CreateDeleteAdditionalService),
    },
});

function PageComponent() {
    const { pathname, search } = Route.useMatch();
    const { currentEnterpriseId, id } = Route.useParams();
    const guideLink = createGuideLink(ArticlePath.CreateDeleteAdditionalService);
    const additionalServicesName = useGetAdditionalServiceName(id);

    return useFeatureFlag(FeatureFlag.productServiceFEMigrationEnabled) ? (
        <ProductServiceDetailPage
            enterpriseId={currentEnterpriseId}
            productServiceId={id}
            guideLink={guideLink}
            additionalServicesName={additionalServicesName}
        />
    ) : (
        <BackendPage url={getBackendPageUrl({ pathname, search })} />
    );
}
